<i18n lang='yml' src='../i18n/TrainingProgramTabs.yml'></i18n>
<template>
  <div class="training_program_standards">
    <ul class="nav nav-tabs">
      <li class="nav-item" v-for="item in tab_objects" :key="`${item.name}-tab`">
        <a :class="`nav-link ${item.active ? 'active' : ''}`"
          :href="item.path"
          v-if="item.name">
          {{ item.name }}
        </a>
      </li>
    </ul>

    <div class="tab-content py-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import LoadingAnimation from '../../../../shared/loader/components/LoadingAnimation.vue';

  export default { 
    props: [
      'locale',
      'tab_objects',
    ],
    components: {
      'loading-animation': LoadingAnimation,
    },
    data() {
      return {
        loading: false,
        activeItem: '',
        error: false,
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;
    },

    methods: {
      /// - Tabs - ///

      isActive (menuItem) {
        return this.activeItem === menuItem
      },

      setActive (menuItem) {
        this.activeItem = menuItem
      },

    },

  }

</script>
